var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PageTile from '@marketing/components/global/tile/PageTile';
import Heading from '@marketing/components/global/typography/Heading';
import { Link } from 'react-router';
import MenuItemList from '../../MenuItemList';
function ExplorePlans(_a) {
    var content = _a.content;
    return (_jsxs("div", __assign({ className: "flex justify-start items-start h-full w-full gap-[360px]" }, { children: [_jsx(MenuItemList, { title: "Get Started", menuItems: [
                    {
                        displayName: 'How it Works',
                        url: content.howItWorksRoute,
                    },
                    {
                        displayName: 'Find in Store',
                        url: content.findInStoreRoute,
                    },
                ] }), _jsxs("div", __assign({ className: "flex flex-col justify-start items-start gap-xs-d" }, { children: [_jsx(Heading, __assign({ tabbable: true, size: "sm", className: "text-text-body" }, { children: "Top Pages" })), _jsxs("div", __assign({ className: "flex justify-start gap-sm-m h-[276px]" }, { children: [_jsx(Link, __assign({ viewTransition: true, to: content.topPages[0].url, className: "hover:no-underline" }, { children: _jsx(PageTile, { useHoverOverlay: true, outline: true, fontColor: "text-text-body", image: {
                                        src: content.topPages[0].imgSrc,
                                        alt: content.topPages[0].title,
                                    }, label: content.topPages[0].title, imageStyles: "h-[182px] w-full border-b-2 border-b-border-shoe rounded-b-none rounded-none", theme: "light" }) }), content.topPages[0].title), _jsx(Link, __assign({ viewTransition: true, to: content.topPages[1].url, className: "hover:no-underline" }, { children: _jsx(PageTile, { useHoverOverlay: true, fontColor: "text-text-body", image: {
                                        src: content.topPages[1].imgSrc,
                                        alt: content.topPages[1].title,
                                    }, label: content.topPages[1].title }) }), content.topPages[1].title)] }))] }))] })));
}
export default ExplorePlans;
